import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { OnsipFormsModule } from "../../shared/components/forms/onsip-forms.module";
import { LoadingModalModule } from "../../shared/components/loadingModal/loading-modal.module";
import { ModalModule } from "../../shared/components/modal/modal.module";
import { EditItemListModule } from "../../shared/components/onsipItemList/edit-item-list.module";
import { SelectionListDeluxeModule } from "../../shared/components/pickers/selectionListDeluxe/selection-list-deluxe.module";
import { PipesModule } from "../../shared/pipes/pipes.module";
import { TableModule } from "../../shared/components/table/onsip-table.module";
import { FormEventTrackingModule } from "../../shared/components/analytics/form-event-tracking.module";
import { AdminE911AddLocationModalComponent } from "./addLocationModal/add-location-modal.component";
import { AdminE911ContainerComponent } from "./container/e911-container.component";
import { AdminE911BaseFormComponent } from "./e911-base-form.component";
import { AdminE911TableComponent } from "./e911Table/e911-table.component";
import { AdminE911TableShelfComponent } from "./e911Table/e911TableShelf/e911-table-shelf-container.component";
import { AdminE911TableShelfEditComponent } from "./e911Table/e911TableShelf/e911TableShelfEdit/e911-table-shelf-edit.component";
import { AdminE911TableShelfViewComponent } from "./e911Table/e911TableShelf/e911TableShelfView/e911-table-shelf-view.component";
import { AdminE911InvoicedPrepaidComponent } from "./emptyStates/invoicedPrepaid/e911-invoiced-prepaid.component";
import { AdminE911NoBalanceComponent } from "./emptyStates/noBalance/e911-no-balance.component";
import { AdminE911NoFreeTrialComponent } from "./emptyStates/noFreeTrial/e911-no-free-trial.component";
import { AdminE911NoLocationComponent } from "./emptyStates/noLocation/e911-no-location.component";
import { AdminE911RoutingModule } from "@onsip/web/features/administrators/e911/adminE911Routing.module";
import { MatStepperModule } from "@angular/material/stepper";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatInputModule } from "@angular/material/input";
import { TableDataLoadContainerModule } from "../../shared/components/tableDataLoadContainer/table-data-load-container.module";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { HeaderModule } from "../../shared/components/layout/header/header.module";
import { MatListModule } from "@angular/material/list";
import { LoadingContainerComponent } from "../../shared/components/loadingContainer/loading-container.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    PipesModule,
    TableModule,
    EditItemListModule,
    LoadingModalModule,
    ModalModule,
    OnsipFormsModule,
    SelectionListDeluxeModule,
    FormEventTrackingModule,
    AdminE911RoutingModule,
    MatStepperModule,
    MatDialogModule,
    MatFormFieldModule,
    MatRadioModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatInputModule,
    TableDataLoadContainerModule,
    MatTableModule,
    MatPaginatorModule,
    FormEventTrackingModule,
    MatSortModule,
    HeaderModule,
    MatListModule,
    AdminE911AddLocationModalComponent,
    LoadingContainerComponent
  ],
  declarations: [
    AdminE911ContainerComponent,
    AdminE911TableComponent,
    AdminE911NoBalanceComponent,
    AdminE911NoLocationComponent,
    AdminE911NoFreeTrialComponent,
    AdminE911InvoicedPrepaidComponent,
    AdminE911TableShelfComponent,
    AdminE911TableShelfViewComponent,
    AdminE911TableShelfEditComponent,
    AdminE911BaseFormComponent
  ]
})
export class AdminE911Module {}
